import { enc, mode, pad, DES} from 'crypto-js'
// import tripledes from 'crypto-js/tripledes'
type TCallback = (content?: string) => void

export const clip = {
  async set(content: string, success: TCallback, fail: TCallback): Promise<void> {
    if (!navigator?.clipboard) {
      fail("navigator.clipboard is not found")
      return
    }
    if (!content?.length) {
      fail("Parameter cannot be null")
      return
    }
    try {
      await navigator.clipboard.writeText(content)
      success()
    } catch (error) {
      fail(`Fail to set:${error}`)
    }

  },
  async get(success: TCallback, fail: TCallback): Promise<void> {
    if (!navigator?.clipboard) {
      fail("navigator.clipboard is not found")
      return
    }
    try {
      const result = await navigator.clipboard.readText()
      success(result)
    } catch (error) {
      fail(`Fail to get:${error}`)
    }
  },
  async clear(success: TCallback, fail: TCallback): Promise<void> {
    if (!navigator?.clipboard) {
      fail("navigator.clipboard is not found")
      return
    }
    try {
      await navigator.clipboard.writeText('')
      success()
      return
    } catch (error) {
      fail(`Fail to clear:${error}`)
    }
  }
}

export const encryptDes = (text: string, key: string, desIv?: string) => {
  const keyHex = enc.Utf8.parse(key)
  let _desIv: string | undefined = desIv;
  desIv ?? (_desIv = "88886666");
  const result = DES.encrypt(text, keyHex, {
      iv: enc.Utf8.parse(_desIv),
      mode: mode.CBC,
      padding: pad.Pkcs7
    })
  return result.toString();
}

export const decryptDes = (text:string, key:string, desIv?:string) => {
  const keyHex = enc.Utf8.parse(key)
  let _desIv: string | undefined = desIv;
  desIv ?? (_desIv = "88886666");
  const result = DES.decrypt(
      text,
      keyHex,
      {
        iv: enc.Utf8.parse(_desIv),
        mode: mode.CBC,
        padding: pad.Pkcs7
      });
  return result.toString(enc.Utf8);
}